import React from 'react'

const Greeting = () => {
  return (
    <div className='container content intro-stage text-center font-weight-bold d-flex align-items-center justify-content-center'>
      <span className='text-white font-weight-bold col-10 col-md-8 m-2'>
        Hi, I'm <br />
        HOÀNG KIM MINH
      </span>
    </div>
  )
}

export default Greeting
